import React, { useState } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  CircularProgress,
  makeStyles
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import CustomerComplaintForm from './CustomerComplaintForm';

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    margin: 0,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    color: 'white',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: 'white',
  },
  dialogContent: {
    padding: theme.spacing(3),
    minWidth: '500px',
    [theme.breakpoints.down('sm')]: {
      minWidth: '300px',
    },
  },
}));

const CustomerComplaintModal = (props) => {
  const {
    open,
    onClose,
    preSelectedClient,
    preSelectedJobsite,
    url,
    user,
    entity,
  } = props;

  const classes = useStyles();
  const [loading, setLoading] = useState(false);

  const handleSubmitComplaint = async (complaintData) => {
    try {
      setLoading(true);

      const payload = {
        clientId: complaintData.clientId,
        jobsiteId: complaintData.jobsiteId,
        complaintType: complaintData.complaintType,
        priority: complaintData.priority,
        description: complaintData.description,
        contactName: complaintData.contactName,
        contactPhone: complaintData.contactPhone,
        contactEmail: complaintData.contactEmail,
        preferredContactMethod: complaintData.preferredContactMethod,
        dateReported: new Date(),
        reportedBy: user?.displayName || user?.email,
        status: 'open',
        entityId: entity?._id
      };

      const response = await axios.post(`${url}/api/customer/complaints/create`, payload);

      if (response.data && response.data.success) {
        if (props.onComplaintCreated) {
          props.onComplaintCreated(response.data.complaint);
        }
        handleClose();
      }
    } catch (error) {
      console.error('Error submitting complaint:', error);
      alert('Failed to submit complaint. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle disableTypography className={classes.dialogTitle}>
        <h2 style={{ margin: 0 }}>Customer Complaint</h2>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleClose}
          disabled={loading}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent className={classes.dialogContent}>
        <CustomerComplaintForm
          preSelectedClient={preSelectedClient}
          preSelectedJobsite={preSelectedJobsite}
          onSubmit={handleSubmitComplaint}
          loading={loading}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          form="complaint-form"
          type="submit"
          variant="contained"
          color="primary"
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} /> : 'Submit Complaint'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = (state) => ({
  url: state.url,
  user: state.user,
  entity: state.entity,
});

export default connect(mapStateToProps)(CustomerComplaintModal);
